<div class="row">
    <div class="col-xs-12">
       <button class="btn btn-success">New Recipe</button> 
    </div>
</div>
<hr>
<div class="row">
    <div class="col-xs-12">
        <app-recipe-item 
        *ngFor="let recipeEl of recipes"
        [recipe]="recipeEl"></app-recipe-item>
    </div>
</div>
